// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#00102f","menuActiveText":"#006dff","subMenuActiveText":"#006dff","menuBg":"#fff","menuHover":"#9ea0a5","subMenuBg":"#fff","subMenuHover":"#fff","sideBarWidth":"210px"};